import { CampaignType, CentralCampaignType } from '@retail/campaign/types';
import { EditableSelectValue, LabelValue } from '@retail/components';
import { useCampaignTFunction } from '@retail/campaign/i18n';
import { useMemo } from 'react';

interface Props {
  type: CampaignType;
  onSave?: (type: CentralCampaignType) => void;
}

export const CampaignTypeView = ({ type, onSave }: Props) => {
  const t = useCampaignTFunction();
  const campaignTypeItems: { name: string; value: CampaignType }[] = useMemo(() => {
    return [
      { name: t('campaign.central'), value: 'CENTRAL' },
      { name: t('campaign.supplier'), value: 'SUPPLIER' },
      { name: t('campaign.optional'), value: 'OPTIONAL' },
    ];
  }, [t]);

  return (
    <LabelValue
      label={t('campaign.columns.campaignType')}
      orientation="vertical"
      value={
        <EditableSelectValue
          editable={!!onSave}
          renderValue={() =>
            t(
              `campaign.${type.toLowerCase()}` as
                | 'campaign.central'
                | 'campaign.supplier'
                | 'campaign.optional'
            )
          }
          onSave={(type) => onSave && onSave(type as CentralCampaignType)}
          defaultValue={type}
          options={campaignTypeItems}
        />
      }
    />
  );
};
